import script from "./FormField.vue3.vue?vue&type=script&setup=true&lang=ts"
export * from "./FormField.vue3.vue?vue&type=script&setup=true&lang=ts"

import "./FormField.vue3.vue?vue&type=style&index=0&id=535601b6&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-535601b6"]])

export default __exports__